export default __webpack_public_path__ + "static/media/772.514f3247.png";